import React from 'react';
import { QueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import type { GroupVisitToTableProps } from './types';

type PatientSearchOptionType = 'schedule-report-totals-patient' | 'schedule-report-totals-patient-unassigned';

export function GroupVisitsByPatientTable<T extends PatientSearchOptionType>(props: GroupVisitToTableProps<T>) {
	return (
		<QueryDataTable<T>
			searchType={props.searchType}
			columns={props.columnDefinitions}
			staticFilters={props.staticFilters}
			getRowId={x => x.patientCode.toString()}
			renderRowDetail={row => (
				<props.tableComponent type="inner-with-filters" staticFilters={[{ name: 'patientCode', operator: '==', value: row.patientCode }]} />
			)}
			emptyMessage="No visits found"
		/>
	);
}
